/* eslint-disable no-unused-vars */
import { KeyboardArrowDown } from "@mui/icons-material";
import { useAtomValue, useSetAtom } from "jotai";
import { SearchIcon } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import { transformAuthUser } from "../../../utils/flatten-attributes";
import { authAtom } from "../../../store/auth";
import logout from "../../../assets/images/logout.png";
import account_circle from "../../../assets/images/account_circle.png";
import settings2 from "../../../assets/images/settings2.png";
import { useRef, useState } from "react";
import useClickOutside from "../../../Hooks/useClickOutside";
import { obIcons } from "../../Icon";
import CurrencySelector from "../../CurrencySelector";
import NotificationBell from "../../Notifications/NotificationBell";
import AppSwitcher, { AppSwitcherMenu } from "../../AppSwitcher";
import { releaseNotificationsOnSignOut } from "../../../utils/signOut";

export const Header = ({ isCollapsed, onToggleCollapse }) => {
	const auth = useAtomValue(authAtom);
	const flattenedUser = transformAuthUser(auth?.user);
	const [profileDropdown, setProfileDropdown] = useState(false);
	const profileRef = useRef(null);
	useClickOutside(profileRef, () => setProfileDropdown(false));
	const setAuth = useSetAtom(authAtom);
	const navigate = useNavigate();

	return (
		<header
			className={`hidden lg:block fixed top-0 right-0 bg-white border-b border-[#D9D9D9] z-30 transition-all duration-300 left-64`}
		>
			<div className="flex items-center justify-between h-16 px-6">
				{/* Left — search */}
				<div className="flex items-center gap-4">
					<div className="relative hidden md:block">
						<SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
						<input
							type="text"
							placeholder="Search..."
							className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-64"
						/>
					</div>
				</div>

				<div className="flex items-center gap-3">
					{/* <CurrencySelector /> */}

					<button className="p-2 bg-[#A2A1A81A] hover:bg-gray-100 rounded-[0.625rem] transition-colors relative">
						<obIcons.chatSupport className="w-5 h-5 text-gray-600" />
					</button>
					<NotificationBell />
					<AppSwitcherMenu />

					{/* Profile */}
					<div className="relative" ref={profileRef}>
						<button
							onClick={() => setProfileDropdown(!profileDropdown)}
							className="flex items-center gap-3 p-2 hover:bg-gray-100 rounded-lg transition-colors"
						>
							{flattenedUser?.attributes?.profile_image ||
							flattenedUser?.attributes?.image ? (
								<img
									src={
										flattenedUser?.attributes?.profile_image ||
										flattenedUser?.attributes?.image
									}
									alt=""
									className="w-8 h-8 rounded-full"
								/>
							) : (
								<div className="w-8 h-8 rounded-full bg-gray-300" />
							)}
							<KeyboardArrowDown className="w-4 h-4 text-gray-600" />
						</button>

						{profileDropdown && (
							<div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
								<div className="px-4 py-3 border-b border-gray-100">
									<p className="text-sm font-medium text-gray-900">
										{flattenedUser?.attributes?.first_name}{" "}
										{flattenedUser?.attributes?.last_name}
									</p>
									<p className="text-sm text-gray-500">
										{flattenedUser?.attributes?.email}
									</p>
								</div>
								<NavLink
									to="/settings"
									className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
									onClick={() => setProfileDropdown(false)}
								>
									<img src={account_circle} alt="" className="w-4 h-4" /> My
									Profile
								</NavLink>
								<NavLink
									to="/settings"
									className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
									onClick={() => setProfileDropdown(false)}
								>
									<img src={settings2} alt="" className="w-4 h-4" /> Settings
								</NavLink>
								<AppSwitcher onSwitch={() => setProfileDropdown(false)} />
								<div className="border-t border-gray-100 mt-2 pt-2">
									<button
										onClick={async () => {
											setProfileDropdown(false);
											await releaseNotificationsOnSignOut();
											setAuth(null);
											navigate("/login");
										}}
										className="flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 w-full text-left"
									>
										<img src={logout} alt="" className="w-4 h-4" /> Sign Out
									</button>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</header>
	);
};
